import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Categories, Country, JobsSTF, MemberShip, Position, Sport, SportGroup, State } from "./catalogs.model";

@Injectable({ providedIn: 'root' })
export class CatalogService {

    constructor(private http: HttpClient) { }

    async findCategories(sport: number) {
        let params = new HttpParams();
        params = params.set('sport', sport.toString());
        return <Categories[]>await this.http.get(environment.urlApi.concat('/catalogs/categories'), {params: params}).toPromise();
    }

    async findMemberShip() {
        return <MemberShip[]>await this.http.get(environment.urlApi.concat('/catalogs/memberships')).toPromise();
    }
    
    async findCountries(): Promise<Country[]> {
      return <Country[]>await this.http.get(environment.urlApi.concat('/catalogs/countries')).toPromise();
    }
    
    async findStates(countryId: number): Promise<State[]> {
      let params = new HttpParams();
      params = countryId ? params.set('country', countryId.toString()) : params.set('country', '1');
      return <State[]>await this.http.get(environment.urlApi.concat('/catalogs/states'), {params: params}).toPromise();
    }
    
    async findJobsTitlesStf(): Promise<JobsSTF[]> {
      return <JobsSTF[]>await this.http.get(environment.urlApi.concat('/catalogs/stf-job-titles')).toPromise();
    }
    
    async findSportsCategory() {
        return <SportGroup[]>await this.http.get(environment.urlApi.concat('/catalogs/sport-groups')).toPromise();
    }
    
    async findSports() {
        return <Sport[]>await this.http.get(environment.urlApi.concat('/catalogs/sports')).toPromise();
    }

    async findPositionsSport(idSport) {
      let params = new HttpParams();
      params = params.set('sport', idSport.toString());
      return <Position[]>await this.http.get(environment.urlApi.concat('/catalogs/positions'), {params: params}).toPromise();
    }

    async findValuationsGroups(data?: { idSport?: number, showAll?: boolean }) {
      let params = new HttpParams();
      if(data && data.idSport) { params = params.set('sport', data.idSport.toString()); }
      data && data.showAll ? params = params.set('showAll', data.showAll) : params = params.set('showAll', 'false')
      return <Position[]>await this.http.get(environment.urlApi.concat('/catalogs/valuations-groups'), {params: params}).toPromise();
    }
    
  }
  